import { render, staticRenderFns } from "./indirizzoinfo.vue?vue&type=template&id=62f85451"
import script from "./indirizzoinfo.vue?vue&type=script&lang=js"
export * from "./indirizzoinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f85451')) {
      api.createRecord('62f85451', component.options)
    } else {
      api.reload('62f85451', component.options)
    }
    module.hot.accept("./indirizzoinfo.vue?vue&type=template&id=62f85451", function () {
      api.rerender('62f85451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/indirizzoinfo.vue"
export default component.exports